import { RxDashboard } from "react-icons/rx";
import { IoDocument } from "react-icons/io5";
import { RiFileUserFill } from "react-icons/ri";
import { FaBookOpen } from "react-icons/fa";

const ManagerDashboardNavData = [
    {
        title: "Dashboard",
        link: "/manager/dashboard",
        icon: <RxDashboard />
    },
    {
        title: "Lessons",
        icon: <IoDocument  />,
        dropdown: [
            {title: "Upload", link: "/manager/dashboard/lessons/upload"},
            {title: "Assign", link: "/manager/dashboard/lessons/assign"},
            {title: "Library", link: "/manager/dashboard/lessons/library"}
        ]
        // link: "/manager/dashboard/lessons"
    },
    {
        title: "Feedback",
        link: "/manager/feedback-employee-list",
        icon: <RiFileUserFill />
    },
    {
        title: "Employee ID Management",
        icon: <FaBookOpen />,
        dropdown: [
            {title: "Create ID", link: "/manager/dashboard/empID-create"},
            {title: "Delete ID", link: "/manager/dashboard/empID-delete"}
        ]
        // link: "/manager/dashboard/empID-management"
    }
];

export default ManagerDashboardNavData;